import React, { useEffect } from 'react';

import AuthStore from '@app/src/common/store/AuthStore';
import RouterStore from '@app/src/common/store/RouterStore';
import ROUTES from '@app/src/common/constants/routeUrls';
import UserManagementRepository from '@app/src/common/repository/UserManagementRepository';

import ErrorPage from '@app/src/common/components/error-page/ErrorPage';
import PdfViewer from '@app/src/common/components/consent/PdfViewer';
import { CustomButton, Modifiers } from '@fw-nextgen/fw-components';

import './ConsentPage.scss';

const ConsentPage = () => {
  useEffect(() => {
    if (!AuthStore.user) {
      RouterStore.navigate(ROUTES.authPage.path);
    }
  }, []);

  const onClick = () => {
    AuthStore.user!.consentFileUrl = undefined;
    UserManagementRepository.acceptConsent(AuthStore.user?.consentFileId!);
    RouterStore.navigate(ROUTES.homePage.path);
  };

  return !AuthStore.user?.consentFileUrl ? (
    <ErrorPage message="error.consentAccepted" />
  ) : (
    <div className="consent-page">
      <div className="consent-page__content">
        <PdfViewer fileDownloadUrl={AuthStore.user.consentFileUrl} />
      </div>
      <div className="consent-page__footer">
        <CustomButton
          id="consent-agree"
          value="general.agree.button"
          modifiers={[Modifiers.SMALL]}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default ConsentPage;
